import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { importEvents as importEventsApi } from "../api/event.api";
import type { EventImportItem, EventImportResponse } from "../types/event.types";

interface UseImportEventsReturn {
  importEvents: (events: EventImportItem[]) => Promise<EventImportResponse>;
  loading: boolean;
  error: string | null;
  reset: () => void;
}

export function useImportEvents(): UseImportEventsReturn {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const reset = useCallback(() => setError(null), []);

  const importEvents = useCallback(async (events: EventImportItem[]) => {
    try {
      setLoading(true);
      setError(null);
      return await importEventsApi(events);
    } catch (importError: unknown) {
      setError(getApiErrorMessage(importError, "Failed to import events"));
      throw importError;
    } finally {
      setLoading(false);
    }
  }, []);

  return { importEvents, loading, error, reset };
}
